module.exports = __webpack_public_path__ + "static/cheese-9142bb082c1a287289a59d8f141e02a8.png";